import React from "react";

const CarSolvencia = ({ componente, solvencia }) => {
    componente === 'CtasCtes' ? componente = 'Cuotas mensuales' : componente = componente;
    const solvente = solvencia === 'Solvente';
    return (
        <tr>
            <td><b>{componente}</b></td>
            <td>
                <span className={solvente ? 'esen-chip esen-chip--success' : 'esen-chip esen-chip--danger'}>
                    <i className={solvente ? 'fa fa-check-circle' : 'fa fa-exclamation-circle'} aria-hidden="true"></i>
                    {solvencia}
                </span>
            </td>
        </tr>
    )
};

export default CarSolvencia;
